export type LocalHistoryRetroHunt = {
  state: number;
  started: string;
  started_username: string;
  stopped: string;
  stopped_username: string | null;
  samples: number;
  location: "local";
};

export type LocalRetroHunt = {
  state: number;
  started: string;
  stopped: string | null;
  samples: number;
  username: string;
  processed: number;
  location: "local";
};

export type RemoteRetroHunt = {
  id: string;
  bucket: string;
  folder: string | null;
  start_time: string;
  end_time: string | null;
  upload_finished: boolean;
  uploaded_count: number;
  processed_count: number;
  status: string;
  username: string;
};

export type ActiveRetroHunt = LocalRetroHunt | RemoteRetroHunt;
export type HistoryRetro = LocalHistoryRetroHunt | RemoteRetroHunt;

export type RetroHunt = {
  active: Array<ActiveRetroHunt>;
  history: Array<HistoryRetro>;
};

export interface ICloudRetro {
  cloud_time: string;
  retro_time: string;
}

export type RemoteRetroHuntStatusResponse = RetroHunt;

export type IYaraStatusResponse = {
  success: boolean;
} & RetroHunt;

export type YaraCloudStatusResponse = {
  success: boolean;
  feed?: ICloudRetro;
};

export type RetroHuntStatus = {
  success: boolean;
  feed?: ICloudRetro;
  cm?: RetroHunt | null;
  local_retro?: RetroHunt;
};

export interface IYaraLocalRetroHuntResponse {
  success: boolean;
  message: string;
}

export interface IYaraRuleset {
  cloud: boolean;
  cloud_status: number;
  errors_count: number;
  favorite: boolean;
  goodware: number;
  id: number;
  is_core: boolean;
  last_matched: string | null;
  malicious: number;
  menu_items: string[];
  name: string;
  publish: boolean;
  reason: string | null;
  retrohunt_estimated_finish_time: string | null;
  retrohunt_finish_time: string | null;
  retrohunt_progress: number | null;
  retrohunt_start_time: string | null;
  retrohunt_status: number;
  scale_status: number;
  show_no_matches_text: boolean;
  status: number;
  suspicious: number;
  unknown: number;
  user: string;
  user_id: number;
  warnings_preview: string[];
  warnings_count: number;
  created_date: string;
  updated_date: string;
  updated_username: string;
  online_source_name?: string;
  online_source_url?: string;
  matches_last_7_days?: number;
  matches_last_24_hours?: number;
  matches_last_month?: number;
  out_of_sync?: boolean;
  online_source_commit_id?: string;
}

export interface IYaraRulesetsResponse {
  items: IYaraRuleset[];
  success: boolean;
}

export type YaraDashboardUrlParams = Record<string, string>;

export interface IMenuItem {
  label: string;
  value: string;
}

export interface IMenuConfig {
  items: IMenuItem[];
  key: string;
}

export interface ISourcesOptions {
  system: IMenuItem[];
  user: IMenuItem[];
}

export interface IYaraRefDataResponse {
  owner_menu: IMenuConfig;
  sources_menu_items: ISourcesOptions;
  ruleset_name_input_max_length: number;
  is_yara_sync_enabled: boolean;
  can_user_publish_to_sdm: boolean;
}

export interface IYaraActionResponse {
  message?: string;
  success: boolean;
}

export interface ISimpleYaraRuleset {
  revision_id: number;
  ruleset_name: string;
}

export interface IYaraSyncStatus {
  synced: boolean;
  rulesets: ISimpleYaraRuleset[];
  has_pending?: boolean;
}

export interface IYaraBulkPublishResponse {
  error_messages: {
    revision_id: number;
    ruleset_name: string;
    message: string;
  }[];
  successful_publish_count: number;
}

export type RetroHuntBucket = {
  hub_group: string;
  bucket: string;
  active_retro_hunt_id: string | null;
};

export type RetroHuntBucketsResponse = Array<RetroHuntBucket>;
